import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "row" }, _ctx.content?.config?.row), [
        _createElementVNode("div", _mergeProps({ class: "col" }, _ctx.content.config?.column), [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.slots, (slot) => {
                return (_openBlock(), _createBlock(_component_g_cms_block, { content: slot }, null, 8, ["content"]));
            }), 256))
        ], 16)
    ], 16));
}
